module.exports = __webpack_public_path__ + "img/taylorBellsCastingHall_20201112_111.1398df26.jpg";